import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const MediaKitsPage = () =>
  import('@/apps/adok/pages/media-kits').then((m) => m.MediaKitsPage)

const mediaKitsRoutes: RouteRecordRaw[] = [
  {
    path: '/advertising/media-kits',
    component: Layout,
    children: [
      {
        path: '',
        name: 'media-kits',
        component: MediaKitsPage,
        meta: {
          title: 'Mediakits'
        }
      },
      {
        path: 'new',
        name: 'media-kits-new',
        component: MediaKitsPage,
        meta: {
          title: 'New Mediakit',
          hidden: true
        }
      },
      {
        path: ':mediaKitId/placements/new',
        name: 'media-kits-placement-new',
        component: MediaKitsPage,
        meta: {
          title: 'New Placement',
          hidden: true
        }
      },
      {
        path: ':mediaKitId/placements/:placementId/edit',
        name: 'media-kits-placement-edit',
        component: MediaKitsPage,
        meta: {
          title: 'Edit Placement',
          hidden: true
        }
      },
      {
        path: ':mediaKitId/edit',
        name: 'media-kits-edit',
        component: MediaKitsPage,
        meta: {
          title: 'Edit Mediakit',
          hidden: true
        }
      }
    ]
  }
]

export default mediaKitsRoutes
